import {
  RESET,
  SET_ERRORS,
  SET_EDIT_MODAL,
  SET_DOCUMENT,
  SET_SHOW_MODAL,
  SET_DOCUMENT_LOADING, SET_LOADING,
} from '../../utils/constants'
import qs from 'qs'

const initialState = () => ({
  headers: [
    {
      text: "Cím",
      value: "title",
      sortable: true,
      divider: true
    },
    {
      text: "Rövidítés",
      value: "abridgment",
      sortable: true,
      divider: true
    },
    {
      text: "Évszám",
      value: "year",
      sortable: true,
      divider: true
    },
    {
      text: "Sorszám",
      value: "serial_number",
      sortable: true,
      divider: true
    },
    {
      text: "Kibocsátó",
      value: "issuer.name",
      sortable: true,
      divider: true
    },
    {
      text: "Szabályzó típus",
      value: "regulator.name",
      sortable: true,
      divider: true
    },
    {
      text: "Hatályba lépés",
      value: "effective_date",
      sortable: true,
      divider: true
    },
    {
      text: "Hatályon kívül helyezés",
      value: "date_of_repeal",
      sortable: true,
      divider: true
    },
    {
      text: "Publikus",
      value: "is_public",
      sortable: false,
      divider: true
    },
    {
      text: "Archivált",
      value: "is_archived",
      sortable: false,
      divider: true
    },
    {
      text: "Inkognító",
      value: "is_incognito",
      sortable: false,
      divider: true
    },
    {
      text: "Csak belső hálózatról elérhető",
      value: "is_internal",
      sortable: false,
      divider: true
    },
    {
      text: "Visszavonásig hatályos",
      value: "valid_until_revoked",
      sortable: false,
      divider: true
    },
    {
      text: "Lehetőségek",
      value: "actions",
      sortable: false
    }
  ],
  document: {
    metas: {},
    is_public: true,
    is_archived: false,
    is_incognito: false,
    is_internal: true,
    effective_date: null,
    date_of_repeal: null,
    valid_until_revoked: false,
    with_archived: false,
    files: [],
    issuer: {},
    issuer_name: "",
    history: { },
    archivedUnder: { },
    parent_id: null,
  }
});

const state = {
  ...initialState(),
  documents: [],
  allDocuments: [],
  issuers: [],
  loading: false,
  latestDocument:{},
};

const getters = {};

Object.keys(state).forEach(key => {
  Object.assign(getters, {
    [key]: state => state[key]
  });
});

const actions = {
  reset({ commit }) {
    commit(RESET);
  },
  getDocuments({ state, rootGetters, dispatch }) {
    axios({
      method: "GET",
      url: "documents",
      params: rootGetters["Table/params"]
    }).then(response => {
      state.documents = response.data.data;

      dispatch("Table/rowsLoaded", { ...response.data.meta }, { root: true });
    });
  },
  getAllDocuments ({ state, commit }) {
    commit(`Axios/${SET_LOADING}`, true, { root: true })
    axios2({
      method: 'GET',
      url: 'documents/getAll',
    }).then(response => {
      state.allDocuments = response.data
    }).finally(() => {
      commit(`Axios/${SET_LOADING}`, false, { root: true })
    })
  },
  createDocument({ state, dispatch }) {
    const formData = prepareSubmit({ state:state, dispatch:dispatch });

    axios.post("documents", formData).then(() => dispatch("getDocuments"));
  },
  async getDocumentById({ state, commit }, id) {
    try {
      const response = await axios(`documents/${id}`);

      Object.assign(state.document, response.data.data)
      commit(SET_DOCUMENT,state.document)
      state.document.issuer_name = state.document.issuer.name

      commit(`Modal/${SET_EDIT_MODAL}`, true, { root: true });
    } catch (error) {
      commit(SET_ERRORS, error, { root: true });
    }
  },
  getDocumentHistory({state, commit}, document) {
        axios(`documents/history/${document.id}`).then(response => {
            document.history = response.data;
        }).catch(error => {
            commit(SET_ERRORS, error, {root: true});
        }).finally(() => {
            commit(`Modal/${SET_SHOW_MODAL}`, true, {root: true})
            commit(SET_DOCUMENT, document)
        })
    },
  updateDocument({ state, dispatch }) {
    let formData = prepareSubmit({ state: state, dispatch: dispatch })

    formData.append("_method", "PATCH");

    axios
      .post(`documents/${state.document.id}`, formData)
      .then(() => dispatch("getDocuments"));
  },
  cloneAndArchiveDocument({ state, dispatch }) {
    let formData = prepareSubmit({ state: state, dispatch: dispatch })

    formData.append("_method", "PATCH");

    axios
      .post(`documents/${state.document.id}/archive`, formData)
      .then(() => dispatch("getDocuments"));
  },
  deleteDocumentById({ dispatch }, id) {
    axios({
      method: "DELETE",
      url: `documents/${id}`
    }).then(() => {
      dispatch("getDocuments");
    });
  },
  deleteAttachmentById({ state, commit }, {id, document}) {
    axios({
      method: "DELETE",
      url: `attached-documents/${id}`
    }).then(() => {
    }).catch(e=>commit(SET_ERRORS, e, {root:true}))
      .finally(()=> {
          document.attached_files = document.attached_files.filter(attached=>attached.id!==id)
          commit(SET_DOCUMENT, document);
          commit(`Modal/${SET_EDIT_MODAL}`, true, {root:true})});
  },
  getAllIssuers({ state }) {
    axios("all/issuers").then(response => {
      state.issuers = response.data.data;
    });
  },
  getLatestDocument ({ state }, issuer_name) {
    axios2.get(`documents/latest?issuer_name=${issuer_name}`).then(response => {
      state.latestDocument = response.data
    })
  },
  getPublicDocuments({ state, rootGetters, dispatch, commit }) {
    commit(SET_DOCUMENT_LOADING, true)
    let filters = { ...rootGetters["Table/filters"] };
    const ordering = { ...rootGetters["Table/orders"] };

    const orders = {};

    for (const [field, order] of Object.entries(ordering)) {
      if (order) {
        if (!orders[`order[${order}]`]) {
          Object.assign(orders, { [`order[${order}]`]: [field] });
        } else {
          orders[`order[${order}]`].push(field);
        }
      }
    }

    const relations = ["metas", "content"];
    const getValueByKey = {
      content: "text"
    };

    relations.forEach(relation => {
      if (filters[relation] && !Array.isArray(filters[relation])) {
        for (const [k, v] of Object.entries(filters[relation])) {
          if (!v) {
            delete filters[relation][k];
          }
        }

        if (Object.keys(filters[relation]) == 0) {
          delete filters[relation];
        }
      } else if (filters[relation]) {
        const items = [...filters[relation]];

        filters[relation] = items.reduce((prev, el) => {
          return prev.concat(el[getValueByKey[relation]]);
        }, []);
      }
    });

    if(Object.keys(filters).length === 0){
        let urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete('page');
        urlSearchParams.delete('limit');
        filters = Object.fromEntries(urlSearchParams.entries());
    }

    const params = {
      ...filters,
      ...rootGetters["Table/params"],
      ...orders
    };

    axios({
      method: "GET",
      url: "documents/filter",
      params
    }).then(response => {
        state.documents = response.data.data;

      const queryString = qs.stringify(
        Object.fromEntries(
          Object.entries(response.config.params).filter(i => i[1]),
        ), { encodeValuesOnly: true },
      )

        window.history.pushState({
                "html": response.html,
                "pageTitle": response.pageTitle
            },
            "",
            `?${queryString}`
        );

      dispatch("Table/rowsLoaded", { ...response.data.meta }, { root: true });
    }).finally(()=> commit(SET_DOCUMENT_LOADING, false));
  }
};

const mutations = {
  [RESET](state) {
    Object.assign(state, initialState());
  },
  [SET_DOCUMENT](state, payload) {
    state.document = { ...payload };
  },
  [SET_DOCUMENT_LOADING](state, payload) {
    state.loading = !!payload;
  }
};

function prepareSubmit({ state, dispatch }){
  const formData = new FormData();

  let obj = {};

  for (const [field, value] of Object.entries({ ...state.document })) {
    obj = {};
    if (
      value instanceof Object &&
      !Array.isArray(value) &&
      field !== "files" &&
      field !== "file"
    ) {
      for (const [k, v] of Object.entries({ ...value })) {
        Object.assign(obj, { [k]: v });
      }
      if (Object.keys(obj).length > 0) {
        formData.append(field, JSON.stringify(obj));
      }
    } else if (field === "files") {
      for (const file of value) {
        formData.append("files[]", file);
      }
    } else {
      formData.append(field, value);
    }
  }

  return formData;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
